import React, { useEffect } from "react";
import { useHistory } from "react-router";
import styled from "styled-components";
import gsap from "gsap";
import ReactGA from "react-ga4";
import { TertiaryButton } from "../../components/Button";
import { WelcomeHeader } from "../../components/Header";
import useLocalStorage from "../../hooks/useLocalStorage";
import Logo from "../../assets/logo.png";
import { devices } from "../../styles";

export default function Welcome() {
  const history = useHistory();
  const [showIntro] = useLocalStorage("showIntro", true);

  useEffect(() => {
    ReactGA.send({ hitType: "pageview", title: `homepage` });
  }, []);

  const handleClick = () => {
    gsap.fromTo(
      [...document.querySelectorAll("#content")],
      { opacity: 1 },
      {
        opacity: 0,
        duration: 1,
        onComplete: () => {
          if (!showIntro) {
            history.push("/questionnaire");
          } else {
            history.push("/intro");
          }
        },
      }
    );
  };

	const handlePromptClick = () => {
		window.location = "https://m2mhosieryhunter.mediuk.co.uk/?src=hh";
	};

  return (
    <Wrapper>
      <WelcomeHeader />
      <Container>
        <Content id="content">
          <img alt="Hosiery Hunter logo" src={Logo} />
          <h3>Welcome to Hosiery Hunter&reg;</h3>
          <h4>This app is brought to you by medi UK</h4>
          <p>
            The aim of this app is to support Healthcare Professionals in
            selecting compression hosiery or wrap products &mdash; to best match
            patient needs. Please click the box below to confirm that you are a
            Healthcare Professional.
          </p>
          <ButtonContainer>
            <TertiaryButton onClick={() => handleClick()}>Confirm</TertiaryButton>
          </ButtonContainer>

          
        </Content>
         <PromptContainer id="content" onClick={handlePromptClick}>

            <h2>Need a made to measure product? </h2>
<p>Go to medi UK Hosiery Hunter® made to measure app <svg xmlns="http://www.w3.org/2000/svg" width="25" height="24" viewBox="0 0 25 24" fill="none">
            <path fillRule="evenodd" clipRule="evenodd" d="M21.8135 10.8994C21.2612 10.8994 20.8135 10.4517 20.8135 9.89941V5.24218L12.6212 13.4345C12.2306 13.825 11.5975 13.825 11.207 13.4345C10.8164 13.044 10.8164 12.4108 11.207 12.0203L19.3989 3.82834H14.7424C14.1901 3.82834 13.7424 3.38062 13.7424 2.82834C13.7424 2.27605 14.1901 1.82834 14.7424 1.82834L19.8135 1.82834C21.4703 1.82834 22.8135 3.17148 22.8135 4.82834V9.89941C22.8135 10.4517 22.3658 10.8994 21.8135 10.8994ZM5.5 3.99978C4.94772 3.99978 4.5 4.44749 4.5 4.99978V18.9998C4.5 19.5521 4.94772 19.9998 5.5 19.9998H19.5C20.0523 19.9998 20.5 19.5521 20.5 18.9998V15.9998C20.5 15.4475 20.9477 14.9998 21.5 14.9998C22.0523 14.9998 22.5 15.4475 22.5 15.9998V18.9998C22.5 20.6566 21.1569 21.9998 19.5 21.9998H5.5C3.84315 21.9998 2.5 20.6566 2.5 18.9998V4.99978C2.5 3.34293 3.84315 1.99978 5.5 1.99978H8.5C9.05228 1.99978 9.5 2.44749 9.5 2.99978C9.5 3.55206 9.05228 3.99978 8.5 3.99978H5.5Z" fill="white"/>
          </svg>
          </p>
          </PromptContainer>
      </Container>
    </Wrapper>
  );
}
const Wrapper = styled.div`
  height: 100%;
  flex: 1;
  display: flex;
  flex-direction: column;
  
`;

const Container = styled.div`
  height: 100%;
  flex: 1;
  background: linear-gradient(206.12deg, #e20074 1.01%, #b9005f 100%);
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 0px 28px;
  
`;

const Content = styled.div`
  color: ${(props) => props.theme.colorSecondary};
  text-align: center;
  width: 320px;
  padding-top: 120px;
  padding-bottom: 40px;

  @media ${devices.tablet} {
    padding-top: 180px;
  }

  img {
    height: 120px;
    width: 120px;
    margin-bottom: 24px;
  }

  h3 {
    margin-bottom: 8px;
  }

  h4 {
    font-size: 18px;
    margin-bottom: 24px;
  }

  p {
    width: 320px;
    margin: 0px auto 56px;
  }

  @media ${devices.tablet} {
    width: 340px;

    h4 {
      margin-bottom: 36px;
    }
  }
`;

const PromptContainer = styled.div`
  background: rgba(255, 255, 255, 0.8);
  border-radius: 8px;
  margin: 24px 0 80px;
  display: flex;
  padding: 16px;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  border-radius: 8px;
  background:  #8D004C;
  width:473px;
  max-width:90vw;
  cursor:pointer;
  color:#fff;

  h2 {
    margin-bottom: 0;
    font-weight:normal;
    font-size: 14px;
  }

  p{
  font-size: 16px;
  font-style: normal;
  font-weight: 700;
  line-height: 24px; /* 150% */
  width:auto;
  padding:0;
  margin:0 0 8px;
  svg{
  vertical-align: middle;
  margin-left: 4px;
  }
`;

const ButtonContainer = styled.div`
  display: flex;
  justify-content: center;
  width: 100%;
  z-index:1
`;
